import React, { Component } from 'react';
import { FiCalendar, FiPhone, FiMapPin } from 'react-icons/fi';
import './receipt.css';
import img from '../../assets/img/default/shop.svg';
import lang from './lang';

const siteUrl = 'https://api.carpetking.uz';

class Receipt extends Component {

    render() {
        const { receipt: { item, price, quantity, total, msg } } = lang[this.props.user.lang || 'uz']
        console.log(this.props.user.lang, lang);


        const logo = process.env.NODE_ENV !== 'development' ? (siteUrl + this.props.logo) : this.props.logo

        return (
            <div id="new-receipt" className="d-none d-print-block" style={styles.div}>
                <table className="table" style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <td colSpan="3">
                                <img src={logo || img} onError={e => e.target.src = img} alt="logo" width="50%" />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="3" style={{ borderTop: 'none', padding: 0, borderBottom: '1px solid' }}>
                                <h5>{this.props.user.name || 'Brand'}</h5>
                            </td>
                        </tr>
                        <tr style={styles.tr}>
                            <td colSpan="3" style={{ paddingTop: '15px' }}>
                                <FiMapPin />  - {this.props.user.address || 'Sh.Rashidov street, 46 uy, Jizzax'}
                            </td>
                        </tr>
                        <tr style={styles.tr}>
                            <td colSpan="3">
                                <FiPhone /> - {this.props.user.phone || "+998 (99) 555-88-77"}
                            </td>
                        </tr>
                        <tr style={styles.tr}>
                            <td colSpan="3" style={{ paddingBottom: '15px' }}>
                                <FiCalendar /> - {new Date(this.props.createdAt).toLocaleString() || '12/05/2019 12:14:15'}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={styles.headding}>
                            <th>{item}</th>
                            <th>{quantity}</th>
                            <th>{price}</th>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px 0' }}>{this.props.name || 'Aurora Carpet'}</td>
                            <td style={{ padding: '10px 0' }}>{this.props.piecesForSale || '0'}</td>
                            <td style={{ padding: '10px 0' }}>{this.props.salePrice || this.props.totalMerchantPrice || '$0'} <sup><small>{this.props.currency}</small></sup></td>
                        </tr>
                        <tr style={styles.price}>
                            <th></th>
                            <th>{total}</th>
                            <th>{this.props.totalValue || '$0'} <sup><small>{this.props.currency}</small></sup></th>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="3" style={styles.footer}>{msg}</td>
                        </tr>
                    </tfoot>
                </table>
            </div >
        )
    }

}

const styles = {
    div: {
        maxWidth: '400px',
        width: '100%',
        background: '#fff',
        margin: 'auto',
        padding: '15px',
        display: 'block'
    },
    table: {
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'Open Sans'
    },
    thead: { textAlign: 'center' },
    footer: { padding: '25px 0', textAlign: 'center' },
    tr: { textAlign: 'left' },
    headding: { borderTop: '1px solid', borderBottom: '1px solid', background: '#eee' },
    price: { borderTop: '1px solid' }
}

export default Receipt;